import { useMutation } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

export const useUpdateContactToCustomer = () => {
  const { toast } = useToast();

  return useMutation({
    mutationFn: async (contactId: string) => {
      console.log("Updating contact to customer status:", contactId);
      
      const { data, error } = await supabase
        .from('profiles')
        .update({ 
          relationship_status: 'Customer',
          customer_since: new Date().toISOString()
        })
        .eq('id', contactId)
        .select()
        .single();

      if (error) {
        console.error("Error updating contact to customer:", error);
        throw error;
      }

      console.log("Successfully updated contact to customer:", data);
      return data;
    },
    onSuccess: () => {
      console.log("Contact successfully marked as customer");
      toast({
        title: "Success",
        description: "Contact updated to customer status",
      });
    },
    onError: (error) => {
      console.error("Failed to update contact to customer:", error);
      toast({
        title: "Error",
        description: "Failed to update contact status",
        variant: "destructive",
      });
    },
  });
};
